import { useMessageSendInfo } from '@/components/hooks/customs/addressBook/useMessageSendInfo';
import { openInfoModalRecoil, openModalRecoil } from '@/recoil/atoms/modalRecoil';
import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { IMessageSendBottom } from './MessageSend.type';
import { softPhoneTopTabRecoil } from '@/recoil/atoms/router/mainRouterRecoil';

const MessageSendInfo = (props: IMessageSendBottom) => {
  const [openModalS, setOpenModalS] = useRecoilState(openModalRecoil);
  const [openInfoModalS, setOpenInfoModalS] = useRecoilState(openInfoModalRecoil);
  // 소프트폰 탭 상태 - 0: 015, 1: 010
  const softPhoneTopTabR = useRecoilValue(softPhoneTopTabRecoil);

  const sendInfoHooks = useMessageSendInfo({
    onClickSendValidation: props.onClickSendValidation,
    softPhoneRowTabState: props.softPhoneRowTabState,
    fileResult: props.fileResult,
    sndMsgState: props.sndMsgState,
    onClickSend: props.onClickSend,
  });

  // // 전송버튼
  // const onClickSendBtn = () => {
  //   // 015홍보모달 표출
  //   setOpenModalS(true);
  // };

  // // 홍보모달 닫히고 전송하기 이벤트 시작
  // useEffect(() => {
  //   if (openInfoModalS) {
  //     setOpenModalS(false);
  //     setOpenInfoModalS(false);
  //     // sendInfoHooks.onClickSendConfirm();
  //   }
  //   if (localStorage.getItem('event2') && openModalS) {
  //     setOpenModalS(false);
  //     sendInfoHooks.onClickSendConfirm();
  //   }
  // }, [openInfoModalS, openModalS]);

  return (
    <button
      className="checkButton"
      onClick={() => {
        sendInfoHooks.onClickSendConfirm();
      }}
      disabled={props.sendMsgLoading || sendInfoHooks.sendInfoIsLoading}
    >
      전송하기
    </button>
  );
};
export default MessageSendInfo;
